import { Text, Icon, Card } from "@chakra-ui/react";

interface ServiceCardProps {
  width?: any;
  service: {
    title: string;
    icon: any;
  };
}

const ServiceCard = ({ width, service }: ServiceCardProps): JSX.Element => {
  return (
    <Card variant={"custom"} width={width}>
      <Icon fontSize={"5xl"} as={service.icon} />

      <Text fontSize={"1.2rem"} fontWeight={"bold"}>
        {service.title}
      </Text>
    </Card>
  );
};

export default ServiceCard;
